export class CatalogDet {
    catDetId: number;
    name: string;
    abbreviation: string;
    orderDisplay: number;
    auxEqvId: number;
    active: boolean;
    auxiliary: string;
    lastDateUpdate: Date;
    lastUserNameUpdate: Date;
    catId: number;
}
